const columnCheck = {
    //device
    deviceModel: 'Model',
    deviceExtra: 'Extra',
    devicePhoneNo: 'PhoneNo',
    IMSI: 'IMSI',
    ICCID: 'ICCID',
    manufacturer: 'Manufacturer',
    serialNumber: 'Serial number',
    softwareVersion: 'Software version',
    productionDate: 'Production date',
    deviceOrg: 'Org',
    deviceStatus: 'Status',
    deviceRemark: 'Remark',
    packageDate: 'Package date',
    operate: 'Operation',
    //alarm
    alarmType: 'Alarm type',
    alarmLevel: 'Alarm level',
    name: 'Name',
    alarmTime: 'Alarm time',
    group: 'Group',
    alarmStatus: 'Status',
    notice: 'Notice',
    description: 'Description',
    //supervise
    power: 'Power',
    lastOnlineTime:'Last online time',
    joinGroupTime: 'Join group time',
    absent: 'Absent',
    姓名:'Name',
    照片:'Photo',
    证件号码:'ID Number',
    身份证号:'ID Number',
    住址:'Address',
    出生日期:'Birthday',
    电话:'Phone',
    入矫时间:'Correction time',
    矫正计划:'Corrective plan',
    人员:'Person'
   
}
export default columnCheck